import { constants } from 'app-constants'

export const setUser = user => ({
  type: constants.SET_USER,
  payload: user
})

export const unsetUser = () => ({
  type: constants.UNSET_USER
})

let savedUser = localStorage.getItem('wabenzyAdmin')
if (!savedUser) savedUser = '{}'
const initialState = JSON.parse(savedUser)

export const authUser = (state = initialState, action) => {
  switch (action.type) {
    case constants.SET_USER:
      localStorage.setItem('wabenzyAdmin', JSON.stringify(action.payload))
      return action.payload
    case constants.UNSET_USER:
      localStorage.removeItem('wabenzyAdmin')
      return {}
    default:
      return state
  }
}
